// extracted by mini-css-extract-plugin
export default {"link":"NavBar__link-pCx5l","active":"NavBar__active-l44D4"};